import { IncidentAction } from './PushMessage';
export interface EventIncident {
    id: number
    action: IncidentAction
    event_id: number
    incident_id: number
    participant_id: number | null
    participant_team_id: number | null
    participant_name: string | null
    status_id: number
    minute: number | null
    second: number | null
    home_score: number | null
    away_score: number | null
    home_score1: number | null
    away_score1: number | null
    home_score2: number | null
    away_score2: number | null
    add_data: string | null
    display_info: number | string | null
    y_pos: number | null
    x_pos: number | null
    ct: number
    ut: number
    attribute_ids: number[]
    confirmation: Confirmation | null
    confirmation_time: number | null
    additional_info: AdditionalInfo
    properties: Properties[]
}

export const enum Confirmation {
    Cancelled = 'cancelled',
    Confirmed = 'confirmed',
}

export type Properties = {
    short_name: string
    value: number | string
};

export type AdditionalInfo = {
    assistant_id?: number
    assistant_name?: string
    secondary_assistant_id?: number
    secondary_assistant_name?: string
    current_ball?: number
    current_over?: number
    current_action?: number
};
